import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Products from './pages/Products';
import Cart from './pages/Cart';
import CategoryView from './pages/ViewbyCategory';
import { CartProvider } from './context/CartContext';
import Footer from './components/Footer';
import PopularProducts from './pages/PopularProducts';
import ProductDetail from './pages/ProductDetail';
import Page404 from './pages/Page404';
import RegisterForm from './pages/RegisterForm';
import Login from './pages/Login';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/PrivateRoutes';
import ForgotPassword from './pages/PasswordForget';
import ResetPasswordConfirm from './pages/ResetPasswordConfirm';
import MyOrders from './pages/MyOrders';
import { ToastContainer } from 'react-toastify';
import ViewReviews from './pages/ViewReviews';
import  CreateReview from './pages/CreateReview';
import CookWithUs from './pages/Cookwithus';
import SearchPage from './pages/Searchpage';
import 'react-toastify/dist/ReactToastify.css';
import EditReview from './components/EditReview';
import Profile from './components/Profile';
import ContactDelivery from './pages/ContactDelivery';
import SuplierPage from './pages/SuplierPage';




function App() {
  return (
    <>
       <ToastContainer position="top-right" autoClose={3000} />
    <AuthProvider>
      <CartProvider>
     
      <Navbar />
      <Routes>  
        <Route path="/search" element={<SearchPage />} />
        <Route path="/" element={<Home />} /> 
        <Route path="/cook-with-us" element={<CookWithUs />} />
        <Route path="/products" element={<Products />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/edit-review/:id" element={<ProtectedRoute><EditReview /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/cart" element={ <ProtectedRoute><Cart /></ProtectedRoute>} />
        <Route path="/category/:categoryName" element={<CategoryView />} />
        <Route path="/reset-password/:uidb64/:token" element={<ResetPasswordConfirm />} />
        <Route path="/my-orders" element={<ProtectedRoute><MyOrders /></ProtectedRoute>} />

        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/popular" element={<PopularProducts />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/register" element={<RegisterForm />} />
        <Route path="/login" element={<Login />} />
        <Route path="/create-review" element={<ProtectedRoute><CreateReview /></ProtectedRoute>} />
        <Route path="/reviews" element={<ViewReviews />} />
        <Route path="/contact-delivery" element={<ContactDelivery />} />
        <Route path="/suplier" element={<SuplierPage />} />
        {/* Add other routes as needed */}
        <Route path="*" element={<Page404 />} />
      </Routes>
      <ViewReviews />
      <Footer/>
      </CartProvider>
    </AuthProvider>
   
    </>
  );
}

export default App;
